import { Outlet } from "react-router-dom";
import ScrollToTop from "./scroll_to_top";

export default function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
}
